import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareBehindSquare1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-behind-square-1, copy 1, layers, pages"} maskId="square-filled-radius-0-stroke-1-IconSquareBehindSquare1"><path fillRule="evenodd" clipRule="evenodd" d="M2 2H16V8H22V22H8V16H2V2ZM15 8H8V15H3V3H15V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareBehindSquare1;
